import React from "react";
import classnames from "classnames";
import { string } from "prop-types";
import { requiredChildren } from "../../propTypes/types";

Card.propTypes = {
  title: string,
  className: string,
  children: requiredChildren,
};

export function Card({ title = null, children = null, className = null, ...props }) {
  return (
    <div className={classnames("card", className)} {...props}>
      <div className="card-body">
        {title && <h3 className="card-title">{title}</h3>}

        {children}
      </div>
    </div>
  );
}
